import { supabase } from '../../services/supabaseClient';
import { buildGetCfgCommand, normalizeGatewayMacHex, resolveGatewayMqttTopics } from '../../utils/gatewayMqttTopics';

const FN = '/.netlify/functions';

export const getMqttAdminUrl = () => `${FN}/gateway-mqtt-admin`;

export { buildGetCfgCommand, normalizeGatewayMacHex, resolveGatewayMqttTopics };

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export async function fetchGatewayConfig(gatewayId) {
  const res = await fetch(`${FN}/gateway-config?id=${encodeURIComponent(gatewayId)}`, {
    headers: await authHeaders(),
  });
  return res.json();
}

export async function saveGatewayConfig(gatewayId, config) {
  const res = await fetch(`${FN}/gateway-config?id=${encodeURIComponent(gatewayId)}`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ config }),
  });
  return res.json();
}

export async function updateGatewayLastSeen(gatewayId) {
  const res = await fetch(`${FN}/gateway-config?id=${encodeURIComponent(gatewayId)}&action=last-seen`, {
    method: 'PATCH',
    headers: await authHeaders(),
  });
  return res.json();
}

/**
 * Send an MQTT admin command via Netlify (DB credentials + lilygo/kbeacon topics from gateway row).
 */
export async function sendMqttAdminCommand(gateway, {
  command,
  timeout = 30,
  waitForResponse = true,
} = {}) {
  const mac = normalizeGatewayMacHex(gateway);
  if (!mac && !gateway?.id) {
    return { success: false, error: 'Gateway MAC not found' };
  }

  const topics = resolveGatewayMqttTopics(gateway);
  const res = await fetch(getMqttAdminUrl(), {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({
      gateway_id: gateway?.id,
      gateway_mac: mac,
      command,
      timeout,
      waitForResponse,
      topics: {
        subAdminTopic: topics.subAdminTopic,
        pubAdminTopic: topics.pubAdminTopic,
      },
    }),
  });

  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    const text = await res.text().catch(() => '');
    return {
      success: false,
      error: `Gateway MQTT function error (${res.status}): ${text ? text.slice(0, 200) : 'Non-JSON response'}`,
    };
  }

  return res.json();
}

/** Probe gateway reachability via MQTT admin getCfg (KGateway + LGateway + MGateway). */
export async function probeGateway(gateway) {
  return sendMqttAdminCommand(gateway, {
    command: buildGetCfgCommand(1),
    timeout: 15,
    waitForResponse: true,
  });
}
